import { render, staticRenderFns } from "./DeptAuthAccount.vue?vue&type=template&id=643e83e2&scoped=true"
import script from "./DeptAuthAccount.vue?vue&type=script&lang=js"
export * from "./DeptAuthAccount.vue?vue&type=script&lang=js"
import style0 from "./DeptAuthAccount.vue?vue&type=style&index=0&id=643e83e2&prod&scoped=true&less=true&lang=css"
import style1 from "./DeptAuthAccount.vue?vue&type=style&index=1&id=643e83e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e83e2",
  null
  
)

export default component.exports